import { useParams } from 'react-router-dom';
import { DiagnosesPage } from './DiagnosesPage';

export const DiagnosesPageWithPatient = (): JSX.Element => {
  const { patientId } = useParams<{ patientId: string }>();
  return <DiagnosesPage patientId={patientId} />;
};
